/**
 * GlobalError/index.js
 * desc: page to catch all application error
 * note: smart component connected to client-side store
 */
'use strict';

import { lazy, Suspense } from 'react';
import { useRouteError } from 'react-router';
import Button from '../../components/Button';
import YmTreeFallingIllustration from '../../components/Illustration/YmTreeFallingIllustration';
import Layout from '../../components/Layout';
import { trackError } from '../../utilities/analytics';
import { translate } from '../../utilities/localization';
import './styles.css';

// lazy like routes.ts, otherwise the static import pins Error404 into the main chunk;
// GlobalError is the root errorElement, so a failed chunk fetch has no handler above it
const Error404 = lazy(() => import('../Error404').catch(() => ({
    default: () => <h1>{ translate('globalError.header.text') }</h1>,
})));

const GlobalError = ({ error }) => {
    let routerError = useRouteError();
    trackError(error || routerError);

    if (routerError?.status === 404) {
        return (
            <Layout>
                <Suspense fallback={ <span></span> }>
                    <Error404 />
                </Suspense>
            </Layout>
        );
    }

    return (
        <section id="global-error">
            <main>
                <YmTreeFallingIllustration />
                <hgroup>
                    <h1>{ translate('globalError.header.text') }</h1>
                    <h2>{ translate('globalError.body.text') }</h2>
                </hgroup>
                <Button
                    className="primary"
                    onClick={ () => window.location.reload() }
                >
                    { translate('globalError.reloadButton.text') }
                </Button>
            </main>
        </section>
    );
};


export default GlobalError;
